import { useState, useCallback } from 'react';
import styled from '@happymoneyinc/styled-components';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const noop = () => {};
const Tooltip = _ref => {
  let {
    children,
    className,
    overlay,
    placement,
    trigger,
    arrow,
    delay,
    ...rest
  } = _ref;
  const [isVisible, setIsVisible] = useState(false);
  const handleMouseIn = useCallback(() => {
    setIsVisible(true);
  }, [setIsVisible]);
  const handleMouseOut = useCallback(() => {
    setIsVisible(false);
  }, [setIsVisible]);
  const handleClick = useCallback(() => {
    setIsVisible(s => !s);
  }, [setIsVisible]);
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsxs(Container, {
      className: className,
      onMouseOver: trigger === 'hover' ? handleMouseIn : noop,
      onMouseLeave: trigger === 'hover' ? handleMouseOut : noop,
      onClick: trigger === 'click' ? handleClick : noop,
      ...rest,
      children: [/*#__PURE__*/jsx(Overlay, {
        "data-testid": "tooltip-overlay",
        className: `tooltip-overlay ${placement}`,
        $arrow: arrow,
        transition: {
          duration: delay,
          ease: 'linear'
        },
        initial: {
          opacity: 0
        },
        animate: {
          opacity: isVisible ? 1 : 0
        },
        $isShowing: isVisible,
        children: overlay
      }), children]
    })
  });
};
const Container = styled.div`
  position: relative;
  display: flex;
`;
const Overlay = styled(motion.div)`
  &.tooltip-overlay {
    position: absolute;
    z-index: 999;
    min-width: 80px;
    padding: 16px;
    color: white;
    font-family: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.fonts.InterRegular;
}};
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.black;
}};
    border-radius: 8px;
    transform: translateX(-50%);
    pointer-events: ${_ref4 => {
  let {
    $isShowing
  } = _ref4;
  return $isShowing ? 'auto' : 'none';
}}
  }

  &.tooltip-overlay::before {
    position: absolute;
    content: "";
  }

  &.tooltip-overlay.top {
    bottom: 100%;
    left: 50%;
    margin-bottom: 10px;
  }

  &.tooltip-overlay.top::before {
    top: 100%;
    left: 50%;
    border-top: 8px solid ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.black;
}};
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    transform: translate(-50%);
    visibility: ${_ref6 => {
  let {
    $arrow
  } = _ref6;
  return $arrow ? 'visible' : 'hidden';
}}
  }

  &.tooltip-overlay.right {
    top: 50%;
    left: 100%;
    margin-left: 10px;
    transform: translate(0, -50%);
  }

  &.tooltip-overlay.right::before {
    top: 50%;
    right: 100%;
    margin-top: -8px;
    border-top: 8px solid transparent;
    border-right: 8px solid ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.black;
}};
    border-bottom: 8px solid transparent;
    visibility: ${_ref8 => {
  let {
    $arrow
  } = _ref8;
  return $arrow ? 'visible' : 'hidden';
}}
  }

  &.tooltip-overlay.bottom {
    top: 100%;
    left: 50%;
    margin-top: 10px;
    margin-bottom: 0;
  }

  &.tooltip-overlay.bottom::before {
    bottom: 100%;
    left: 50%;
    border-right: 8px solid transparent;
    border-bottom: 8px solid ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.black;
}};
    border-left: 8px solid transparent;
    transform: translate(-50%);
    visibility: ${_ref10 => {
  let {
    $arrow
  } = _ref10;
  return $arrow ? 'visible' : 'hidden';
}}
  }

  &.tooltip-overlay.left {
    top: 50%;
    right: 100%;
    margin-right: 10px;
    transform: translate(0, -50%);
  }

  &.tooltip-overlay.left::before {
    top: 50%;
    left: 100%;
    margin-top: -8px;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.black;
}};
    visibility: ${_ref12 => {
  let {
    $arrow
  } = _ref12;
  return $arrow ? 'visible' : 'hidden';
}}
  }
`;
Tooltip.defaultProps = {
  placement: 'bottom',
  trigger: 'hover',
  arrow: true,
  delay: 0,
  children: null,
  overlay: null,
  className: ''
};
Tooltip.propTypes = {
  className: PropTypes.string,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  trigger: PropTypes.oneOf(['click', 'hover']),
  arrow: PropTypes.bool,
  delay: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  overlay: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
var Tooltip$1 = Tooltip;

export { Tooltip$1 as default };
//# sourceMappingURL=Tooltip.js.map
